import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AdapterLink from '../../components/common/adapterLink';
import { useStoreState } from 'easy-peasy';
import {
  Box,
  GridList,
  Typography,
  GridListTile,
  GridListTileBar,
} from '@material-ui/core';
import imgParams from '../../utils/imageUtil';
import { getPostLanguage } from '../../services/authService';
import { useGetMyCommunities } from '../../hooks/communityHooks';

const MyCommunitiesCarousel = () => {
  const classes = useStyles();
  const listOfCommunities = useGetMyCommunities();
  const webLanguage = getPostLanguage();
  const language = useStoreState((state) => state.languages[webLanguage]);

  return listOfCommunities && listOfCommunities.length > 0 ? (
    <Box className={classes.root}>
      <Box px={4} py={3} className={classes.communityHeading}>
        <Typography align="left" variant="subtitle2" display="inline">
          {/* My Communities */}
          {language.ID_MY_COMMUNITIES}
        </Typography>
        <Typography
          align="right"
          variant="overline"
          className={classes.allCommunityLink}
          to="/my-communities"
          component={AdapterLink}
        >
          View All
        </Typography>
      </Box>
      <Box className="clearfix"></Box>
      <GridList className={classes.gridList} cols={3.5}>
        {listOfCommunities &&
          listOfCommunities.slice(0, 10).map((myCommunity, index) => (
            <GridListTile
              key={`${index}`}
              className={classes.gridTilteSet}
              to={myCommunity.communitySlug}
              component={AdapterLink}
            >
              <img
                src={imgParams(myCommunity.thumbnailImageUrl, 80, 80)}
                alt={myCommunity.logoAltText}
                className={classes.imgSet}
              />
              <GridListTileBar
                title={myCommunity.name}
                classes={{
                  root: classes.titleBar,
                  title: classes.title,
                }}
              />
            </GridListTile>
          ))}
      </GridList>
    </Box>
  ) : (
    ''
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    background: 'white',
    borderRadius: '15px',
    height: '140px',
  },
  gridList: {
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
    height: '140px',
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: '12px',
  },
  gridTilteSet: {
    height: 'auto!important',
    padding: '0px!important',
    textAlign: 'center',
    textDecoration: 'none',
  },
  imgSet: {
    top: 0,
    height: 'auto',
    borderRadius: '50%',
    width: '56px',
    transform: 'inherit',
    left: 'inherit',
    border: ' 1px solid #f1f1f1',
  },
  titleBar: {
    background: 'inherit',
    position: 'relative',
    height: 'inherit',
    display: 'inherit',
  },
  communityHeading: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  allCommunityLink: {
    color: theme.palette.link.main,
    textDecoration: 'none',
  },
}));

export default MyCommunitiesCarousel;
